/**
 * Nombre usable en plantillas WA/email ({nombre}).
 * Omite placeholders de MarketPlace / CRM (Particular, Contacto, etc.)
 * para no saludar «Hola Particular, …».
 */

const NOMBRES_NO_USABLES = new Set([
  "particular",
  "particulares",
  "contacto",
  "contactos",
  "propietario",
  "propietaria",
  "propietarios",
  "propietarias",
  "sin nombre",
  "sinnombre",
  "destinatario",
  "destinataria",
  "cliente",
  "clientes",
  "desconocido",
  "desconocida",
  "anonimo",
  "anonima",
  "titular",
  "agencia",
  "inmobiliaria",
  "unknown",
  "n/a",
  "na",
  "none",
  "null",
  "undefined",
  "-",
  "—",
  ".",
]);

function normalizarClaveNombre(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

/** Primer token del nombre completo. */
export function primerNombre(n) {
  if (n == null) return "";
  const t = String(n).trim();
  if (!t) return "";
  return t.split(/\s+/)[0] || "";
}

/**
 * ¿Se puede usar este nombre en un saludo/plantilla?
 * Acepta el nombre completo o solo el de pila.
 */
export function esNombreUsableParaPlantilla(nombre) {
  const raw = String(nombre || "").trim();
  if (!raw) return false;
  const key = normalizarClaveNombre(raw);
  if (!key) return false;
  if (NOMBRES_NO_USABLES.has(key)) return false;
  // Primera palabra sola también puede ser placeholder («Particular López»)
  const pila = normalizarClaveNombre(primerNombre(raw));
  if (pila && NOMBRES_NO_USABLES.has(pila)) return false;
  return true;
}

/**
 * Nombre de pila para {nombre}, o '' si no es un nombre real.
 * No hace fallback a «cliente» / «Particular».
 */
export function nombreParaPlantillaMensaje(raw) {
  const completo = String(raw || "").trim();
  if (!completo || !esNombreUsableParaPlantilla(completo)) return "";
  const pila = primerNombre(completo);
  return pila || completo;
}

/**
 * Sustituye {nombre} / {agente} y limpia huecos si el nombre no es usable
 * («Hola , …» → «Hola, …»; «Здравствуйте, !» → «Здравствуйте!»).
 */
export function aplicarPlaceholdersMensaje(texto, nombreCliente, nombreAgente) {
  let s = String(texto ?? "");
  const nom = String(nombreCliente || "").trim();
  const age = String(nombreAgente || "").trim();
  s = s.replace(/\{nombre\}/gi, nom);
  s = s.replace(/\{agente\}/gi, age);
  s = s.replace(/VitalCasa/gi, "Vitalcasa");
  // Artefactos al omitir nombre
  s = s.replace(/\s+,/g, ",");
  s = s.replace(/,\s*,/g, ",");
  s = s.replace(/,\s*!/g, "!");
  s = s.replace(/[^\S\r\n]{2,}/g, " ");
  return s;
}
